import React from 'react'

import Cookies from 'universal-cookie';
import logo from '../img/perfil.jpg';
import CambioContraseña from './cambioContraseña';

//impoertacion componentes

function Index() {
    const cookie = new Cookies();
    const postData = e => {
        window.location.reload("/")
    };
    return (
        <div className="test">
            <div className="container">
                <div className="text-center">
                    <div class="container-fluid">
                        <div class="card shadow mb-4">
                            <div class="card-header py-3">
                                <h6 class="m-0 font-weight-bold text-primary">Información del perfil</h6>
                            </div>

                            <div class="card-body">
                                <div class="table-responsive">
                                    <img src={logo} width="150" />
                                    <br></br>
                                    <br></br>
                                    <form className="user">

                                        <div className="form-group row">
                                            <div className="col-sm-12">
                                                <input type="text" className="form-control form-control-user" placeholder={"Nombre: "+cookie.get("Nombre")} disabled />
                                            </div>
                                        </div>

                                        <div className="form-group row">
                                            <div className="col-sm-6 mb-3 mb-sm-0">
                                                <input type="text" className="form-control form-control-user" placeholder={"Correo Electronico: "+cookie.get("correo")} disabled />

                                            </div>


                                            <div className="col-sm-6 ">

                                                <input type="text" className="form-control form-control-user" placeholder={"Regional: "+cookie.get("regional")} disabled />

                                            </div>
                                        </div>


                                        <div className="form-group row">
                                            <div className="col-sm-12">
                                                <input type="text" className="form-control form-control-user" placeholder={"Area: "+cookie.get("area")} disabled />
                                            </div>
                                        </div>
                                        <CambioContraseña/>
                                        <hr/>
                                        <a ><button className="btn btn-primary btn-user btn-block" type='submit' onClick={postData}>Aceptar</button></a>

                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Index;
